import LocalStorageService from '@/services/localStorageService';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

const localStorageService = new LocalStorageService();
const isDarkModeEnabled = localStorageService.isDarkModeEnabled();

export default new Vuetify({
  theme: { dark: isDarkModeEnabled }
});
